import http from "../helpers/http-common"

class ReviewsService {

    /* Internal Reviews */

    getFilters() {
        return http.get(`/reviews/filters`);
    }

    search(params) {
        return http.post(`/reviews/search`, params);
    }

    getStats(params) {
        return http.post(`/reviews/stats`, params);
    }

    getList(params) {
        return http.post(`/reviews/list`, params);
    }

    /* Store Reviews */

    getStoreFilters() {
        return http.get(`/reviews/store-filters`);
    }

    getStoreList(params) {
        return http.post(`/reviews/store-list`, params);
    }

    getStoreStats(params) {
        return http.post(`/reviews/store-stats`, params);
    }

    refreshStoreReview(params) {
        return http.post(`/reviews/store-review-refresh`, params);
    }

    replyStoreReview(params) {
        return http.post(`/reviews/store-review-reply`, params);
    }

    generateReplyStoreReview(params) {
        return http.post(`/reviews/store-review-generate-reply`, params);
    }
}

export default new ReviewsService();
